import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {useGetSessionUser} from '../../../../core/use-get-session-user';
import {useUpdateUserSetting} from '../../../../core/use-update-user-setting';

type UnlockConfirmation = {
    shouldShow: boolean;
    onHideUnlockConfirmation: () => Promise<any>;
};

export const useShowUnlockConfirmation = (): {
    unlockConfirmation: UnlockConfirmation | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {user, isLoading, errorMessage: error} = useGetSessionUser();
    const updateUserSetting = useUpdateUserSetting();

    const unlockConfirmation = user
        ? {
              shouldShow: !user.hasDismissedCompanyUnlockConfirmation,
              onHideUnlockConfirmation: () =>
                  updateUserSetting({
                      userId: user.id,
                      settingName: Nut_Settings_User.SETTING_HIDE_COMPANY_UNLOCK_CONFIRMATION,
                      value: '1',
                      propertyOnUser: 'hasDismissedCompanyUnlockConfirmation',
                  }),
          }
        : undefined;

    return {
        isLoading,
        error,
        unlockConfirmation,
    };
};
